import { LogOut } from 'lucide-react'
import { useLocation } from 'react-router-dom'
import { logout } from '../../services/authService'
import { ModeSwitcher } from './ModeSwitcher'
import { Navigation } from './Sidebar'

function getMobileTitle(pathname: string): string {
  if (pathname === '/' || pathname.startsWith('/chat')) return ''
  if (pathname.startsWith('/memory')) return 'Memory'
  if (pathname.startsWith('/settings')) return 'Settings'
  if (pathname.startsWith('/documents')) return 'Documents'
  if (pathname.startsWith('/line')) return 'My Calls'
  if (pathname.startsWith('/profile') || pathname.startsWith('/my-info')) return 'Profile'
  if (pathname.startsWith('/household')) return 'Household'
  if (pathname.startsWith('/tasks')) return 'Activity'
  if (pathname.startsWith('/dashboard')) return 'Dashboard'
  if (pathname.startsWith('/knowledge')) return 'Knowledge'
  if (pathname.startsWith('/routing')) return 'Routing'
  if (pathname.startsWith('/campaigns')) return 'Campaigns'
  if (pathname.startsWith('/accounts')) return 'Accounts'
  if (pathname.startsWith('/compliance')) return 'Compliance'
  if (pathname.startsWith('/lists')) return 'Lists'
  if (pathname.startsWith('/pricing')) return 'Pricing'
  return ''
}

export function MobileHeader({ isMenuOpen, onToggleMenu }: { isMenuOpen: boolean; onToggleMenu: () => void }) {
  const location = useLocation()
  const title = getMobileTitle(location.pathname)

  return (
    <header className="mobile-header">
      <button
        className={`hamburger-btn ${isMenuOpen ? 'open' : ''}`}
        onClick={onToggleMenu}
        aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={isMenuOpen}
      >
        <span /><span /><span />
      </button>
      {title && !isMenuOpen && (
        <span className="mobile-header-title">{title}</span>
      )}
    </header>
  )
}

export function MobileMenu({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  return (
    <>
      <div className={`mobile-menu-overlay ${isOpen ? 'open' : ''}`} onClick={onClose} aria-hidden="true" />
      <div className={`mobile-menu ${isOpen ? 'open' : ''}`}>
        <ModeSwitcher />
        <Navigation onNavigate={onClose} />
        <div style={{ marginTop: '2rem' }}>
          <button
            onClick={async () => { await logout(); window.location.href = '/' }}
            style={{
              display: 'flex', alignItems: 'center', gap: '0.75rem',
              padding: '0.75rem 1rem', marginTop: '0.75rem', color: '#9ca3af',
              background: 'transparent', border: 'none', borderRadius: '8px',
              cursor: 'pointer', fontSize: '0.875rem', width: '100%',
            }}
          >
            <LogOut size={18} />Log out
          </button>
        </div>
      </div>
    </>
  )
}
